import { Context } from '@/types/context'
import { useMainStore } from './main'

export async function initializeStores({ app, pinia }: Context): Promise<void> {
  app.use(pinia)

  const mainStore = useMainStore(pinia)
  await mainStore.init()
}
